import { create } from 'zustand';
import { ApiUtils, ApplicationApi, RequestStrategyEnum } from '@shared/api';

interface ISubmitManualApplicationStore {
  loading: boolean;
  error: string | null;
  success: boolean;
  submitManualApplication: (manualApplicationId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useSubmitManualApplicationStore = create<ISubmitManualApplicationStore>((set) => ({
  loading: false,
  error: null,
  success: false,

  submitManualApplication: ApiUtils.wrapperApi(async (manualApplicationId: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      await ApplicationApi.submitManualApplication(manualApplicationId, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ success: false, loading: false, error: null }),
}));
